<template>
  <div class="page" v-if="info !== null">
    <!-- <NavBar title="默契答题" /> -->
    <!-- <van-nav-bar title="默契问答" :left-arrow="true" :fixed="true" @click-left="back" /> -->
    <div class="app-detail">
      <div class="wrapper" v-if="current_position == 0">
        <HomeIcon position="right" />
        <div class="bd-box">
          <img class="avatar" mode="aspectFill" :src="info.avatar" />
          <div class="nickname">{{ info.owner_name }}：</div>
          <div class="title">{{ info.title }}</div>
          <div class="question-count">题目数量：{{ info.lists.length }}题</div>
        </div>
        <div class="people" v-if="info.is_owner">
          {{ curr_join }}人正在答题， {{ total_join }}人已答完
        </div>
        <div class="footer">
          <!-- 模版 -->
          <div v-if="tempId">
            <div class="btns-box w600 mt60">
              <div class="btn btn-red" @click="copyTemplate">
                选用模版
              </div>
            </div>
            <div class="btns-box w600 ">
              <div class="btn try-btn" @click="startAnswer(1)">
                体验答题
              </div>
            </div>
          </div>
          <!-- 出题人 -->
          <template v-else>
            <div v-if="info.is_owner == 1">
              <div class="btns-box w600" v-if="isInApp">
                <div class="btn btn-red" @click="share">
                  邀请成员
                </div>
              </div>
              <div class="btns-box w600">
                <div class="btn btn-red" @click="toRank">
                  排行榜
                </div>
                <div
                  class="btn btn-red ml30"
                  @click="info.has_joined ? toRecord() : startAnswer()"
                >
                  {{ info.has_joined ? "查看成绩" : "开始答题" }}
                </div>
              </div>
            </div>
            <!-- 参与者 -->
            <div class="btns-box w600 mt60" v-else>
              <div class="btn btn-red" @click="toRank">
                排行榜
              </div>
              <div
                class="btn btn-red ml30"
                @click="info.has_joined ? toRecord() : startAnswer()"
              >
                {{ info.has_joined ? "查看成绩" : "开始答题" }}
              </div>
            </div>
          </template>
        </div>
        <Contact :isWhite="true" />
      </div>
      <div class="question-box" v-if="current_position > 0">
        <div class="h-top">
          <div class="h-text">
            题目 <label>{{ current_position }}/{{ info.lists.length }}</label>
          </div>
        </div>
        <div class="progress-box">
          <van-progress
            :percentage="(current_position / count) * 100"
            :show-pivot="false"
          />
        </div>
        <div class="q-box" v-if="questions.length">
          <div class="q-title">
            {{ current_position }}.{{ questions[current_position - 1].desc }}
          </div>
          <div
            class="q-opt"
            v-for="(item, index) in questions[current_position - 1].options"
            :key="index"
            @click="changeOpt(index, current_position - 1)"
          >
            <label :class="item.checked ? 'checked letter' : 'letter'">{{
              item.letter
            }}</label>
            <div>{{ item.content }}</div>
          </div>
        </div>
        <div v-if="current_position == 1" class="mt60">
          <div class="btn btn-red" @click="assignNext(current_position + 1)">
            下一题
          </div>
        </div>
        <div class="btns-box mt60" v-else-if="current_position == count">
          <div class="btn btn-red" @click="assignPrev(current_position - 1)">
            上一题
          </div>
          <div
            class="btn btn-red ml30"
            @click="assignNext(current_position + 1)"
          >
            提交
          </div>
        </div>
        <div class="btns-box mt60" v-else>
          <div class="btn btn-red" @click="assignPrev(current_position - 1)">
            上一题
          </div>
          <div
            class="btn btn-red ml30"
            @click="assignNext(current_position + 1)"
          >
            下一题
          </div>
        </div>
      </div>
    </div>
    <ContactImg :visible="showContact" @hideVisible="handleContact()" />
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import api from "@/utils/api";
import { Toast, Dialog } from "vant";
import {
  deepClone,
  getToken,
  updateJoinStatus,
  setShareInfo,
  reLogin,
  getQueryString,
  getBindToken,
  showServiceAble
} from "@/utils/common";
import Contact from "@/components/contact";
import ContactImg from "@/components/contactImg";
import HomeIcon from "@/components/homeIcon";

let timer = null;
export default {
  data() {
    return {
      showContact: false,
      qid: "",
      current_position: 0,
      info: null,
      hasUserInfo: false,
      curr_join: 0,
      total_join: 0,
      questions: [],
      meet_name: "",
      config: "",
      errcode: "",
      tempId: "",
      isInApp: wemeet.app.isTMWebview(),
      try: 0,
      start_time: '',
    };
  },
  components: { Contact, ContactImg, HomeIcon },
  async mounted() {
    this.qid = this.$route.query.qid;
    this.tempId = this.$route.query.tempId || "";

    if (this.isInApp && getQueryString("auth_code")) {
      let res = await getBindToken(getQueryString("auth_code"));
      if (res) {
        let preToken = localStorage.getItem("token");
        localStorage.setItem("token", res.access_token);
        localStorage.setItem("bind_status", res.bind_status || 0);
        this.$router.replace({
          name: "tacitDetail",
          query: { qid: this.qid }
        });
        localStorage.removeItem("qid");
        this.getDetail(preToken ? "" : "directTodo");
      }
      return;
    }
    this.getDetail();
  },
  destroyed() {
    if (this.current_position && this.qid && !this.try) {
      updateJoinStatus(0, this.qid);
    }
  },
  methods: {
    copyTemplate() {
      let param = {
        qid: this.qid,
        access_token: getToken(),
        copy_type: 1,
        temp_id: this.tempId,
        version_code: 1,
        xcx_version: "1.0.0"
      };
      questionOnly.post("/xcx/ques/v1/copy_create", param).then(res => {
        if (res.sta == 0) {
          Toast("创建成功");
          this.tempId = "";
          this.$router.replace({
            name: "tacitDetail",
            query: { qid: res.data.qid }
          });
          this.qid = this.$route.query.qid;
          this.tempId = this.$route.query.tempId;
          this.getDetail();
        } else if (res.sta === -500) {
          localStorage.setItem(
            "template_id",
            JSON.stringify({
              qid: this.qid,
              temp_id: this.tempId,
              type: 5
            })
          );
          reLogin("template_id");
        } else {
          Toast(res.msg);
        }
      });
    },
    back() {
      this.$router.replace({ name: "questionList" });
    },
    share() {
      window.wemeet.app.shareOpenApp();
    },
    async handleContact() {
      let res = await showServiceAble();
      if(res) {
        this.showContact = !this.showContact;
      }
    },
    startAnswer(type) {
      if (type) {
        // 体验模版
        this.try = 1;
        this.current_position = 1;
        return;
      }
      if (!getToken()) {
        return this.handleErr("/tacit/tacitDetail?qid=" + this.qid);
      }
      let param = {
        access_token: getToken(),
        qid: this.qid
      };
      questionOnly.post(api.question.getStart, param).then(res => {
        if (res.sta == 0) {
          this.start_time = res.data.now;
          updateJoinStatus(1, this.qid);
          clearInterval(timer);
          timer = null;
          this.current_position = 1;
        } else if (res.sta === -1 && res.errcode === 110) {
          Dialog.confirm({
            title: "温馨提示",
            message: "答题参与人数已达到上限，如需增加上限需前往小程序设置",
            confirmButtonText: "联系客服",
            cancelButtonText: "我知道了",
            confirmButtonColor: "#1890ff"
          })
            .then(() => {
              this.showContact = true;
            })
            .catch(() => {});
        } else if (res.sta === -500) {
          this.handleErr("/tacit/tacitDetail?qid=" + this.qid);
        } else {
          Dialog.alert({
            title: "温馨提示",
            message: res.msg,
            confirmButtonColor: "#1890ff"
          });
        }
      });
    },
    changeOpt(index, current_position) {
      let copyList = deepClone(this.questions);
      for (const i in copyList[current_position].options) {
        copyList[current_position].options[i].checked = 0;
      }
      copyList[current_position].options[index].checked = 1;
      this.questions = copyList;
    },
    assignNext(position, type = undefined) {
      let { current_position, questions, count } = this;
      let current_que = deepClone(questions[current_position - 1]) || {};
      if (current_position == 0) {
        this.current_position = 1;
      } else if (current_que.options) {
        let has_checked = 0;
        for (const i in current_que.options) {
          if (current_que.options[i].checked) {
            has_checked = 1;
          }
        }
        if (has_checked) {
          if (position == count + 1) {
            this.saveQuestion();
          } else {
            this.current_position = position;
          }
        } else if (type == undefined) {
          Toast("请选择答案");
          return;
        } else if (type == "prev") {
          this.current_position = position;
        }
      }
    },
    saveQuestion() {
      // Toast(this.meet_name)
      let copyData = deepClone(this.questions),
        optC = {};
      for (let i in copyData) {
        let item = copyData[i];
        optC[i] = {};
        optC[i]["id"] = item.qqid ? item.qqid : item.id;
        optC[i]["options"] = item.options;
        optC[i]["type"] = 0;

        let opt = item.options;
        let has_checked = 0;
        for (let j in opt) {
          let _item = opt[j];
          if (_item.checked) has_checked = 1;
        }
        if (has_checked == 0) {
          util.showModelTips(
            "第" + parseInt(i + 1) + "题没有选择答案，请选择后再保存"
          );
          obj = {};
          return;
        }
      }
      let bind_status = localStorage.getItem('bind_status') || 0

      let param = {
        qid: this.qid,
        lists: optC,
        is_trial: 0,
        time: 0,
        ...(this.try ? {} : { access_token: getToken() }),
        ...(this.try ? { source: "meet_temp" } : {}),
        is_force: 0,
        t_start: this.start_time,
        ...this.isInApp && bind_status != 1 ? { meet_name: this.meet_name } : {},
        submit_source: this.isInApp ? 2 : 1,
      };
      questionOnly.post(api.question.questionSubmit, param).then(res => {
        if (res.sta == 0) {
          let query = this.try ? { try: 1 } : { rid: res.data.rid };
          if (this.try) {
            localStorage.setItem("tryResult", JSON.stringify(res.data));
          }
          this.$router.push({
            name: "tacitResult",
            query: query
          });
        } else {
          Toast(res.msg);
        }
      });
    },
    assignPrev(position) {
      this.assignNext(position, "prev");
    },
    toRank() {
      this.$router.push({ name: "rank", query: { qid: this.qid } });
    },
    toRecord() {
      this.$router.push({ name: "tacitResult", query: { rid: this.info.rid } });
    },
    getDetail(directTodo) {
      let self = this;
      let param = {
        qid: self.qid,
        access_token: getToken()
      };
      questionOnly.get(api.question.getQuestionDetial, param).then(res => {
        if (res.sta == 0) {
          self.info = res.data;
          self.questions = res.data.lists;
          self.count = res.data.lists.length;
          if (res.data.is_owner) {
            self.getJoinStatus();
          }
          setShareInfo(true, self.info.title);
          if(localStorage.getItem('detailShare')) {
            this.share();
            localStorage.removeItem('detailShare')
          }
          if (self.isInApp) {
            let { nickname = "" } = JSON.parse(localStorage.getItem("userInfo"));
            self.meet_name = nickname;
            if (directTodo) self.startAnswer();
          }
        } else if (res.sta === -500) {
          self.handleErr("/tacit/tacitDetail?qid=" + self.qid);
        } else {
          Toast(res.msg);
        }
      });
    },
    getJoinStatus() {
      if (this.$route.name != "tacitDetail") {
        clearInterval(timer);
        timer = null;
        return;
      }
      let param = {
        qid: this.qid,
        access_token: getToken()
      };
      questionOnly.get(api.question.getJoinStatus, param).then(res => {
        if (res.sta == 0) {
          this.curr_join = res.data.curr_join;
          this.total_join = res.data.total_join;
          if (!timer) {
            timer = setInterval(() => {
              this.getJoinStatus();
            }, 5000);
          }
        } else {
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
          Toast(res.msg);
        }
      });
    },
    handleErr(url = "") {
      if (this.isInApp) {
        localStorage.setItem(
          "qid",
          JSON.stringify({
            qid: this.qid,
            type: 5
          })
        );
      }
      reLogin("qid", url);
    }
  }
};
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  /deep/ .van-nav-bar .van-icon {
    color: #262626;
  }
}
.consoleInfo {
  background: #fff;
}

.app-detail {
  background: linear-gradient(180deg, #0e5ed8 0%, #1b228e 100%);
  background-attachment: fixed;
  min-height: calc(100vh);
  // margin-top: 44px;
}
.wrapper {
  padding: rem(120) 0 rem(30);
}
.bd-box {
  position: relative;
  box-sizing: border-box;
  width: rem(600);
  border-radius: rem(24);
  background: #fff;
  margin: 0 auto;
  padding: rem(30);
  filter: drop-shadow(0 rem(2) rem(40) rgba(0, 0, 0, 0.4));
}
.avatar {
  position: absolute;
  left: rem(33);
  top: rem(-60);
  width: rem(120);
  height: rem(120);
  border-radius: 50%;
  border: rem(4) solid #fff;
}
.nickname {
  padding-top: rem(70);
  font-size: rem(56);
  line-height: rem(84);
  color: #fe6895;
  font-weight: 900;
}
.title {
  font-size: rem(56);
  line-height: rem(84);
  color: #1a2794;
  font-weight: 900;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.question-count {
  margin-top: rem(30);
  border-top: rem(4) dashed #1345b9;
  font-size: rem(26);
  color: #999;
  line-height: rem(45);
  padding: rem(30) 0;
}
.footer {
  width: rem(600);
  margin: 0 auto;
  // padding: rem(60) 0 0;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: rem(90);
  color: #fff;
  font-size: rem(34);
  border-radius: rem(48);
  box-sizing: border-box;
  cursor: pointer;
}
.btn-blue {
  background: #080e88;
  border: rem(4) solid #fe6895;
}
.btn-red {
  background: #fe6895;
}
.btns-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: rem(30);
}
.btns-box div {
  flex: 1;
}
.w600 .btn {
  // width: rem(285) !important;
}
.btn-rank {
  color: #fff;
  font-size: rem(26);
  /* text-decoration: underline; */
  text-align: center;
  padding: rem(15) 0;
  margin-top: rem(30);
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-rank .line {
  margin: rem(10);
}

/* question */
.question-box {
  padding: rem(30);
}
.h-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
}
.h-text {
  font-size: rem(30);
}
.h-text label {
  font-weight: 900;
}
.h-right {
  display: flex;
  align-items: center;
}
.h-more {
  font-size: rem(28);
  padding: 0 rem(20);
}
.h-change {
  display: flex;
  align-items: center;
  justify-content: center;
  width: rem(160);
  height: rem(60);
  border-radius: rem(30);
  background: #fff;
  font-size: rem(26);
  color: #000;
}
.h-change image {
  width: rem(26);
  height: rem(26);
  margin-right: rem(10);
}
.progress-box {
  margin-top: rem(20);
}

.q-box {
  background: #fff;
  border-radius: rem(8);
  margin-top: rem(60);
  padding: rem(30);
  font-size: rem(30);
}
.q-title {
  padding-bottom: rem(20);
  font-size: rem(32);
}
.q-opt {
  display: flex;
  align-items: center;
  padding: rem(15) 0;
}
.q-opt .letter {
  border-radius: 50%;
  width: rem(60);
  height: rem(60);
  line-height: rem(60);
  text-align: center;
  background: #f6f6f6;
  margin-right: rem(15);
}
.q-opt view {
  flex: 1;
  line-height: 1.5;
}
.opt-right {
  font-size: rem(26);
  color: #999;
}
.q-opt .checked {
  background: #1890ff;
  color: #fff;
}
.ml30 {
  margin-left: rem(30);
}
.mt60 {
  margin-top: rem(60);
}
.people {
  margin: rem(30) auto;
  text-align: center;
  color: #fff;
}
.try-btn {
  border: rem(4) solid #fe6895;
  box-shadow: 0 rem(4) rem(4) #000000;
  border-radius: rem(80);
  background: #080e88;
}
</style>



// WEBPACK FOOTER //
// src/pages/tacit/tacitDetail/tacitDetail.vue